import React, { useState, useEffect } from "react";
import "./featurecategory.css"; 
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseURL } from "../../constants/url";

function FeatureCategory() {
  const [subcategories, setSubcategories] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const bgColors = [
    "#F2FCE4", "#FFFCEB", "#ECFFEC", "#FCF1BD", "#F2FCE4",
    "#FFF3EB", "#FFF3FF", "#FDF0EA", "#ECFFEC", "#f8d63b61",
    "#FFFCEB", "#CCD9EC", "#DCEEFF", "#FEEFEA"
  ];

  useEffect(() => {
    const fetchSubcategories = async () => {
      try {
        const res = await axios.get(`${baseURL}common/subcategories/`);
        const data = res.data || [];
        setSubcategories(data);
        setTotalCount(data.length);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };
    fetchSubcategories();
  }, []);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1000,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 8 } },
      { breakpoint: 1200, settings: { slidesToShow: 6 } },
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="container-fluid fetures_cat_slider">
      <div className="heading_common">
        <h3>Feature Categories</h3>
       </div>
      <Slider {...settings} className="catSlider">
        {subcategories.map((sub, index) => (
          <div className="item" key={sub.id || index}>
            <div className="item_in" style={{ background: bgColors[index % bgColors.length] }}>
              <figure className="img-hover-scale overflow-hidden">
                <Link  to={`/subcategoriesproducts/${sub.id}`}tabIndex="0">
                  <img
                    src={sub.image || "/default-image.png"}
                    alt={sub.name}
                    onError={(e) => (e.target.src = "/default-image.png")}
                  />
                </Link>
              </figure>
              <h6 className="font_13">
                <Link  to={`/subcategoriesproducts/${sub.id}`} tabIndex="0">
                  {sub.name}
                </Link>
              </h6> 
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default FeatureCategory;
